import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=d54aaf02"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d54aaf02')) {
      api.createRecord('d54aaf02', component.options)
    } else {
      api.reload('d54aaf02', component.options)
    }
    module.hot.accept("./Personal.vue?vue&type=template&id=d54aaf02", function () {
      api.rerender('d54aaf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/concept_components/Personal.vue"
export default component.exports